import { Input } from "antd"
import styled from "styled-components"

const InputStyled = styled(Input)`
  &[readonly] {
    background: none;
    border-color: #d9d9d9 !important;
    box-shadow: none !important;
    color: #1677ff;
    cursor: pointer;
  }
`

function FormItemStaticLink({ typeData }) {
  return <InputStyled value={typeData.value} readOnly onClick={typeData.onClick} />
}

export default FormItemStaticLink;